import { FormProvider, useForm } from "react-hook-form";
import { useContext } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { GeaoContext } from "../../../GeaoContextProvider";
import { ClientConfigurationContext } from "../../../../../context/ClientConfigurationContextProvider";
import GeaoVerticalStepperLayout from "../../shared/Layout/GeaoVerticalStepperLayout";
import PrincipalFlowVerticalStepperElements from "../../../constants/PrincipalFlowVerticalStepperElements";
import useTitle from "../../../../../hooks/useTitle";
import { validationSchema } from "./validation";
import useFormEvents from "./useFormEvents";
import LocationInfoSection from "../../shared/PersonalInformation/LocationInfoSection";
import CaptiveAgentQuestions from "./CaptiveAgentQuestions";
import { interviewToFormData } from "./mappers";
import RadioButtonGroup from "../../../../gds/RadioButtonGroup";
import PersonalInfoSection from "../../shared/PersonalInformation/PersonalInfoSection";
import EmployeeInfoSection from "../../shared/PersonalInformation/EmployeeInfoSection";
import WorkArrangementOptions from "../../../constants/options/WorkArrangementOptions";
import LinesOfBusinessSection from "../../shared/PersonalInformation/LinesOfBusinessSection";
import useGtmTracking from "../../../../../hooks/useGtmTracking";

export default function PrincipalPersonalInformation() {
    useTitle("Personal Information");

    useGtmTracking("Onboarding:PrincipalPersonalInfo", "onboarding_principal_in_progress");

    const { agentInterview, interviewIsCompleted } = useContext(GeaoContext);
    const clientConfiguration = useContext(ClientConfigurationContext);

    const enableOffshore = clientConfiguration?.enableOffshore === true;
    const formDefaults = interviewToFormData(agentInterview);
    if (!enableOffshore) {
        formDefaults.isOffshoreResident = false;
    }

    const useFormReturn = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: formDefaults
    });

    const {
        handleSubmit,
        getValues,
        trigger,
        control
    } = useFormReturn;

    const {
        onSubmit,
        onSaveAndExit,
        saving
    } = useFormEvents(getValues, trigger);

    return (
        <GeaoVerticalStepperLayout
            verticalStepperElements={PrincipalFlowVerticalStepperElements}
            currentStepperItem="Personal Information"
            header="Personal Information"
        >
            <FormProvider {...useFormReturn}>
                <form className="form geao-form" onSubmit={handleSubmit(onSubmit)}>
                    <PersonalInfoSection />
                    <LocationInfoSection />
                    <EmployeeInfoSection showLicensedProducerQuestions={false} />
                    <CaptiveAgentQuestions />

                    <RadioButtonGroup
                        control={control}
                        name="workArrangement"
                        legend={<>
                            What is your current work arrangement?{/*
                            */}<span className='required'>*</span>
                        </>}
                        descriptiveCopy="Select how you primarily work."
                        layout="One Column"
                        options={WorkArrangementOptions}
                    />

                    <LinesOfBusinessSection />

                    <p>
                        <span className='required'>*</span> Indicates required field.
                    </p>

                    <div className="margin-top">
                        <button
                            type="submit"
                            className="btn btn--primary btn--full-mobile btn--pull-right"
                            disabled={saving || interviewIsCompleted}
                        >
                            <span>Next</span>
                        </button>

                        <button
                            type="button"
                            className="btn btn--secondary btn--full-mobile btn--pull-right"
                            disabled={saving || interviewIsCompleted}
                            onClick={onSaveAndExit}
                        >
                            <span>Save And Exit</span>
                        </button>
                    </div>
                </form>
            </FormProvider>
        </GeaoVerticalStepperLayout>
    );
}